import React, { lazy } from 'react';
import { MessageCircleIcon, StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const videos = ['https://cdn.magicpatterns.com/uploads/hXxBkXZdkKMc9HZkUNXXrZ/test%201%20.mp4', 'https://cdn.magicpatterns.com/uploads/rrvBCRxjWZnEyv1jz83DKM/test%202.mp4', 'https://cdn.magicpatterns.com/uploads/dS2tgTn49tUkrVF8b9k8BV/test%203.mp4'];
  const textReviews = [{
    initials: 'PD',
    color: 'bg-blue-600',
    name: 'Pablo Díaz',
    time: 'hace 2 horas',
    text: 'En mi primer mes ya recuperé la inversión. Ahora cobro $300 por tablero y antes cobraba $150. Todo gracias a que entendí bien los comandos.'
  }, {
    initials: 'MG',
    color: 'bg-emerald-600',
    name: 'Mónica Gutierrez',
    time: 'hace 5 horas',
    text: 'Pasé de ganar $800 al mes a más de $1,200 semanales. La plantilla de presupuestos me ayudó a cotizar como profesional y los clientes confían más.'
  }, {
    initials: 'JR',
    color: 'bg-indigo-600',
    name: 'Julián Ramirez',
    time: 'hace 1 día',
    text: 'Trabajo solo y ahora puedo cobrar entre $400 y $600 por instalación. Antes no me animaba a aceptar trabajos industriales por miedo a equivocarme.'
  }, {
    initials: 'CV',
    color: 'bg-purple-600',
    name: 'Carla Vasquez',
    time: 'hace 1 día',
    text: 'Como mujer en este rubro es difícil que te tomen en serio. Pero cuando muestro mis trabajos bien hechos, cobro lo mismo que cualquiera: $250-$400 por proyecto.'
  }, {
    initials: 'MO',
    color: 'bg-orange-600',
    name: 'Matías Ortega',
    time: 'hace 2 días',
    text: 'Duplicé mis ingresos en 3 meses. Ahora hago trabajos de automatización que pagan $500-$800 y antes solo hacía instalaciones básicas de $100.'
  }, {
    initials: 'RI',
    color: 'bg-teal-600',
    name: 'Rodrigo Iglesias',
    time: 'hace 3 días',
    text: 'Los clientes me piden presupuestos más grandes ahora. El mes pasado facturé $3,200 solo con comandos eléctricos. Antes ganaba eso en 3 meses.'
  }, {
    initials: 'NR',
    color: 'bg-red-600',
    name: 'Nicolás Ramirez',
    time: 'hace 4 días',
    text: 'Mi primer arranque estrella-triángulo lo cobré $450. Antes ni sabía qué era eso. Ahora es mi especialidad y gano bien.'
  }, {
    initials: 'AS',
    color: 'bg-cyan-600',
    name: 'Andrés Sosa',
    time: 'hace 5 días',
    text: 'Aprendí a calcular motores y a cotizar bien. Pasé de $600 mensuales a $1,000 semanales. La diferencia es saber cuánto vale tu trabajo.'
  }];
  return <section className="bg-[#0D1117] py-10 px-4 border-y border-white/10" data-id="element-449">
      <div className="max-w-[900px] mx-auto" data-id="element-450">
        <h2 className="text-[26px] text-center font-bold text-brand-black mb-10 leading-[1.2] heading-underline flex items-center justify-center gap-2" data-id="element-451">
          <MessageCircleIcon className="w-6 h-6 text-primary" data-id="element-452" />
          LO QUE DICEN PERSONAS COMO TÚ
        </h2>

        {/* Video Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-453">
          {videos.map((videoSrc, idx) => <div key={`vid-${idx}`} className="bg-brand-black-light border border-white/10 rounded-xl p-4 shadow-sm flex flex-col items-center" data-id="element-454">
              <div className="flex text-primary mb-4" data-id="element-455">
                <StarIcon className="w-4 h-4 fill-current" data-id="element-456" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-457" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-458" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-459" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-460" />
              </div>
              <div className="w-full rounded-lg overflow-hidden border border-white/5 bg-brand-black-light aspect-[9/16]" data-id="element-461">
                <video controls playsInline className="w-full h-full object-cover" preload="none" data-id="element-462">
                  <source src={videoSrc} type="video/mp4" data-id="element-463" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
            </div>)}
        </div>

        {/* Text Testimonials (Facebook Style without actions) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-464">
          {textReviews.map((review, idx) => <div key={`txt-${idx}`} className="bg-brand-black-light border border-primary/30 rounded-lg p-4 shadow-sm flex flex-col" data-id="element-465">
              <div className="flex items-center gap-3 mb-3" data-id="element-466">
                <div className={`w-10 h-10 rounded-full ${review.color} flex items-center justify-center text-white font-bold text-sm flex-shrink-0`} data-id="element-467">
                  {review.initials}
                </div>
                <div data-id="element-468">
                  <div className="font-bold text-brand-black text-[15px] leading-tight" data-id="element-469">
                    {review.name}
                  </div>
                  <div className="flex items-center gap-1 text-xs text-dark-gray mt-0.5" data-id="element-470">
                    <span data-id="element-471">{review.time}</span>
                    <span data-id="element-472">·</span>
                    <span className="flex text-primary" data-id="element-473">
                      <StarIcon className="w-3 h-3 fill-current" data-id="element-474" />
                      <StarIcon className="w-3 h-3 fill-current" data-id="element-475" />
                      <StarIcon className="w-3 h-3 fill-current" data-id="element-476" />
                      <StarIcon className="w-3 h-3 fill-current" data-id="element-477" />
                      <StarIcon className="w-3 h-3 fill-current" data-id="element-478" />
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-white text-[15px] leading-relaxed" data-id="element-479">
                "{review.text}"
              </p>
              {review.name === 'Pablo Díaz' && <div className="mt-4 rounded-lg overflow-hidden border border-white/10" data-id="element-480">
                  <img loading="lazy" src="https://cdn.magicpatterns.com/uploads/cjrDd75N8ELtmFBu8u9sim/test_4.png" alt="Testimonio de Pablo" className="w-full h-auto block" data-id="element-481" />
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}